import { Cart, CartItem, CART_STORAGE_KEY } from "@/types/registration";

export function loadCart(): Cart | null {
  try {
    const raw = localStorage.getItem(CART_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Cart;
  } catch {
    return null;
  }
}

export function saveCart(cart: Cart) {
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
  } catch {
    // ignore quota
  }
}

export function clearCart() {
  try {
    localStorage.removeItem(CART_STORAGE_KEY);
  } catch {
    // ignore
  }
  clearWizardState();
}

// ── Wizard state (step, which team is being edited, in-progress values) ──
// Persisted alongside the cart so leaving the tab never loses position.

export const WIZARD_STORAGE_KEY = "rle_registration_wizard_v1";

export interface WizardState {
  event_slug?: string | null;
  step?: string;
  editingClientId?: string | null;
  /** Free-text the coach has typed but not yet committed, keyed by cart item. */
  drafts?: Record<string, string>;
}

export function loadWizardState(): WizardState | null {
  try {
    const raw = localStorage.getItem(WIZARD_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as WizardState;
  } catch {
    return null;
  }
}

export function saveWizardState(patch: Partial<WizardState>) {
  try {
    const current = loadWizardState() ?? {};
    localStorage.setItem(
      WIZARD_STORAGE_KEY,
      JSON.stringify({ ...current, ...patch })
    );
  } catch {
    // ignore quota
  }
}

export function saveWizardDraft(clientId: string, value: string) {
  const current = loadWizardState() ?? {};
  const drafts = { ...(current.drafts ?? {}) };
  if (value) drafts[clientId] = value;
  else delete drafts[clientId];
  saveWizardState({ drafts });
}

export function clearWizardState() {
  try {
    localStorage.removeItem(WIZARD_STORAGE_KEY);
  } catch {
    // ignore
  }
}


export function newClientId() {
  return `ci_${Math.random().toString(36).slice(2, 10)}`;
}

export function emptyCart(user: {
  id: string;
  email: string;
  name?: string;
}): Cart {
  const [first = "", ...rest] = (user.name ?? "").trim().split(/\s+/);
  return {
    id: null,
    items: [],
    registrant_user_id: user.id,
    registrant_email: user.email,
    registrant_name: user.name ?? "",
    registrant_first_name: first,
    registrant_last_name: rest.join(" "),
  };
}

export function newItem(partial: Partial<CartItem> = {}): CartItem {
  return {
    client_id: newClientId(),
    event_id: "",
    event_name: "",
    team_name: "",
    team_id: null,
    recruitlook_team_id: null,
    club_id: null,
    club_name: null,
    new_club_name: null,
    new_short_name: null,
    team_display_name: "",
    team_home_zip: null,
    catalog_division_id: "",
    division_label: "",
    gender: "boys",
    base_price: 0,
    coach_name: "",
    coach_email: "",
    registrant_is_coach: false,
    requested_constraints: [],
    extras: [],
    matched_via: null,
    match_score: null,
    rejected_match_ids: [],
    scheduling_tier: "standard",
    scheduling_tier_fee: 0,
    scheduling_draft: null,
    ...partial,
  };
}
